import React from 'react';
import { Button, Input, Tabs } from 'antd';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { toast } from 'react-toastify';
import axios from '../../../helpers/axios';

const DefaultValues = {
  newpassword: '12345678',
  confirmpassword: '12345678',
  currentpassword: 'password123#',
};

function Password({ GetProfileDetails }) {
  const methods = useForm(DefaultValues);

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
    getValues,
    setValue,
    reset,
  } = methods;

  const tempSubmit = async () => {
    const resp = await axios.put(`/admin/password/update`, {
      newpassword: watch('newpassword'),
      confirmpassword: watch('confirmpassword'),
      currentpassword: watch('currentpassword'),
    });
    if (resp.status < 400) {
      GetProfileDetails();
      toast.success(resp.data?.message);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(tempSubmit)}>
        <div className='pl-[57px] pb-[30px] max-[800px]:p-[20px] max-w-[700px]'>
          <h3 className='text-[15px] text-[#27272B] font-[600] mb-[16px]'>
            Password Details
          </h3>
          <div className='frm_inp mb-[22px]'>
            <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
              Current Password
            </label>
            <Controller
              control={control}
              name='currentpassword'
              rules={{
                required: true,
                minLength: {
                  value: 8,
                  message: 'Password must have atleast 8 characters',
                },
              }}
              render={({ field, fieldState }) => {
                return (
                  <Input.Password
                    {...field}
                    placeholder='Enter a password'
                    className='input-w-common'
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                    visibilityToggle
                    value={field.value}
                    status={fieldState.error ? 'error' : ''}
                  />
                );
              }}
            />
          </div>
          <div className='frm_inp mb-[22px]'>
            <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
              New Password
            </label>
            <Controller
              control={control}
              name='newpassword'
              rules={{
                required: true,
                minLength: {
                  value: 8,
                  message: 'Password must have atleast 8 characters',
                },
              }}
              render={({ field, fieldState }) => {
                return (
                  <Input.Password
                    {...field}
                    placeholder='Enter a password'
                    className='input-w-common'
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                    visibilityToggle
                    value={field.value}
                    status={fieldState.error ? 'error' : ''}
                  />
                );
              }}
            />
          </div>
          <div className='frm_inp mb-[22px]'>
            <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
              Confirm Password
            </label>
            <Controller
              control={control}
              name='confirmpassword'
              rules={{
                required: true,
                validate: (value) =>
                  value === getValues('newpassword') ||
                  'Passwords do not match',
              }}
              render={({ field, fieldState }) => {
                return (
                  <Input.Password
                    {...field}
                    placeholder='Confirm Password'
                    className='input-w-common'
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                    visibilityToggle
                    value={field.value}
                    status={fieldState.error ? 'error' : ''}
                  />
                );
              }}
            />
            {errors.confirmpassword && (
              <p className='text-[13px] text-[#ff4d4f]'>
                {errors.confirmpassword.message}
              </p>
            )}
          </div>
          <div className='mt-[40px]'>
            <Button className='prof_btn save' htmlType='submit'>
              Update Password
            </Button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export default Password;
